import { render, staticRenderFns } from "./vin-fail-content.vue?vue&type=template&id=5afa9137&scoped=true"
import script from "./vin-fail-content.vue?vue&type=script&lang=js"
export * from "./vin-fail-content.vue?vue&type=script&lang=js"
import style0 from "./vin-fail-content.vue?vue&type=style&index=0&id=5afa9137&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa9137",
  null
  
)

export default component.exports